import { Link } from "react-router-dom";
import { Flex } from "@100mslive/roomkit-react";
import EventHeaderHosting from "./EventHeaderHosting";

const EventHeaderTop = ({ pathname }) => {
  return pathname === "/" ? (
    <Flex className="events6ix-layout-header-top">
      <div className="events6ix-layout-header-top-text">
        Looking to join an event?
      </div>
      <Link to="/explore" className="events6ix-layout-header-top-link">
        Explore Events
      </Link>
    </Flex>
  ) : (
    <Flex className="events6ix-layout-header-top">
      <div className="events6ix-layout-header-top-text">
        Interested in hosting your own event?
      </div>
      <EventHeaderHosting />
    </Flex>
  );
};

export default EventHeaderTop;
